import axios from "axios";
import { app } from "../config";
import getHeaders from "./authHeaders";

export const getSerial = async (shortCode) => {
  try {
    // let resp = await axios.post(`https://websitestagging.know.us/api/v1/admin/inventory/mapping?shortCode=oxJI1-ckyj9`,{}, { headers: getHeaders() });
    
    let resp = await axios.post(`${app.URL}/api/v1/admin/inventory/mapping?shortCode=${shortCode}`, {}, { headers: getHeaders() });
    console.log('resp', resp?.data?.result?.data?.serialNo);
    const serial = resp?.data?.result?.data?.serialNo;

    
    // setisEncrypt(false);
    return serial
  } catch (error) {
    console.log('error in getSerial', error);
    // setisEncrypt(false);
  }
};
